import React from 'react';
import fond1 from '../images/FLUX-2025-12-08-14_42_11.png';

function HeroSection() {
    const backgroundImage = fond1;

    return (
        <header
            className="hero-section"
            id="home"
            style={{
                backgroundImage: `url(${backgroundImage})`,
            }}
        >
            {/* Overlay */}
            <div className="overlay"></div>

            {/* Content */}
            <div className="hero-content">
                <h1 className="hero-title">Antiquaire Expert Paris</h1>
                <p className="hero-subtitle">
                    Expertise | Estimation | Rachat
                </p>
                <p className="hero-subtitle">
                    Déplacement et expertise gratuite à Paris et en Île-de-France.
                </p>
                <div className="hero-buttons">
                    <a href="/#contact" className="hero-button">
                        Demandez votre estimation
                    </a>
                    <a href="tel:0658084516" className="hero-button yellow-bg">
                        06 58 08 45 16
                    </a>
                </div>
            </div>

            <style jsx>{`
                .hero-section {
                    background-size: cover;
                    background-position: center bottom;
                    background-attachment: fixed;
                    height: 70vh;
                    color: #fff;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                }

                .overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1;
                }

                .hero-content {
                    position: relative;
                    z-index: 2;
                    text-align: center;
                    padding: 20px;
                }

                .hero-title {
                    font-size: 3rem;
                    font-weight: bold;
                    color: #fff;
                    margin-bottom: 10px;
                }

                .hero-subtitle {
                    font-size: 1.5rem;
                    font-style: italic;
                    color: #d4af37;
                    margin-bottom: 20px;
                }

                .hero-buttons {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    align-items: center;
                }

                .hero-button {
                    background-color: #20453d;
                    color: #fff;
                    padding: 15px 25px;
                    text-decoration: none;
                    border-radius: 5px;
                    font-weight: bold;
                    font-size: 1rem;
                    width: 80%;
                    text-align: center;
                    max-width: 300px;
                }

                .yellow-bg {
                    background-color: #ffd700;
                    color: #000;
                }

                /* Mobile adjustments */
                @media (max-width: 768px) {
                    .hero-section {
                        height: 40vh;
                        margin-top: 75px;
                        background-size: 175vw;
                        background-position: top;
                    }

                    /* Reduce title and subtitle sizes */
                    .hero-title {
                        font-size: 1.8rem;
                    }

                    .hero-subtitle {
                        font-size: 1.0rem;
                        line-height: 1.3;
                        margin-bottom: 10px;
                        margin-top: 10px;
                    }

                    /* Stack buttons vertically */
                    .hero-buttons {
                        flex-direction: column;
                    }

                    /* Slightly smaller button text and padding */
                    .hero-buttons .hero-button {
                        font-size: 0.8rem;
                        padding: 8px 0px;
                        margin-bottom: 10px;
                    }
                }
            `}</style>
        </header>
    );
}

export default HeroSection;
